import { Typography } from '../../../../../design-system/components/typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlower, faMoneyBillWave } from '@fortawesome/pro-solid-svg-icons';
import {
  CopyLinkModal,
  CopyLinkModalProps,
} from '@design-system/components/modals/CopyLinkModal';

export const SuccessModal = (
  p: Pick<CopyLinkModalProps, 'isOpen' | 'onClose' | 'url'>,
) => (
  <CopyLinkModal
    title="Share your campaign"
    linkTitle="Campaign link"
    linkDesc="Share this unique link to drive traffic and track performance. Use it to measure engagement, boost conversions, and optimize your strategy effortlessly"
    tooltip={<CampaignInfo />}
    {...p}
  />
);

const CampaignInfo = () => (
  <div className="p-[1em]">
    <Typography
      variant="body"
      size="medium"
      style={{ padding: '0 0 16px' }}
      color="B-100"
    >
      What to do next?
    </Typography>
    <Typography
      variant="body"
      size="small"
      color="N-80"
      style={{ paddingBottom: '8px' }}
    >
      <FontAwesomeIcon
        color="N-80"
        icon={faMoneyBillWave}
        style={{ paddingRight: '8px' }}
      />
      PAID ADS
    </Typography>
    <Typography variant="body" size="small" color="B-100" fontWeight="normal">
      {`If you’re running paid campaign such as Facebook or Instagram ads - make
      sure to add this URL to the Campaign Manager. `}
    </Typography>
    <Typography
      variant="body"
      size="small"
      color="N-80"
      style={{ paddingBottom: '8px', paddingTop: '16px' }}
    >
      <FontAwesomeIcon
        color="N-80"
        icon={faFlower}
        style={{ paddingRight: '8px', textTransform: 'uppercase' }}
      />
      ORGANIC CAMPAIGN
    </Typography>
    <Typography variant="body" size="small" color="B-100" fontWeight="normal">
      Make sure to paste link in respective place like Linktree, Instagram
      stories, email etc.
    </Typography>
  </div>
);
